"use strict";

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/esnext.global-this.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { IS_PRODUCTION } from '@autoguru/global-configs';
import { createContext, useContext, useEffect, useState } from 'react';
// TODO: Use graph type for PricingModeEnum when schema is available
import { jsx as _jsx } from "react/jsx-runtime";
const determineInitialPriceDisplaySetting = incomingSetting => {
  switch (incomingSetting) {
    case 'EXCLUDING_TAX':
    case 'INCLUDING_TAX':
      return incomingSetting;
    default:
      return 'INCLUDING_TAX';
  }
};
const PriceDisplaySettingsContext = /*#__PURE__*/createContext(undefined);
export const PriceDisplaySettingsProvider = ({
  children,
  priceDisplaySetting: incomingPriceDisplaySetting,
  constant: _constant = false
}) => {
  const [priceDisplaySetting, setPriceDisplaySetting] = useState(determineInitialPriceDisplaySetting(incomingPriceDisplaySetting));
  const [userPriceDisplayToggle, setUserPriceDisplayToggle] = useState(determineInitialPriceDisplaySetting(incomingPriceDisplaySetting));
  const [readOnly, setReadOnly] = useState(priceDisplaySetting !== userPriceDisplayToggle);
  useEffect(() => {
    setReadOnly(priceDisplaySetting !== userPriceDisplayToggle);
  }, [priceDisplaySetting, userPriceDisplayToggle]);
  const togglePriceDisplaySetting = () => {
    setUserPriceDisplayToggle(userPriceDisplayToggle === 'INCLUDING_TAX' ? 'EXCLUDING_TAX' : 'INCLUDING_TAX');
  };

  // Add a debugging window handle
  if (!JSON.parse(IS_PRODUCTION) && !_constant) {
    globalThis['__setPriceDisplayIncTax'] = incTax => {
      setPriceDisplaySetting(incTax ? 'INCLUDING_TAX' : 'EXCLUDING_TAX');
    };
    globalThis['__togglePriceDisplayIncTax'] = togglePriceDisplaySetting;
  }
  return /*#__PURE__*/_jsx(PriceDisplaySettingsContext.Provider, {
    value: {
      priceDisplaySetting,
      setPriceDisplaySetting,
      togglePriceDisplaySetting,
      userPriceDisplayToggle,
      setUserPriceDisplayToggle,
      readOnly
    },
    children: children
  });
};
export const usePriceDisplaySettings = () => {
  const context = useContext(PriceDisplaySettingsContext);
  if (!context) {
    throw new Error('usePriceDisplaySettings must be used within a PriceDisplaySettingsProvider');
  }
  return context;
};